import { useState, useEffect } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import { FormField } from '../../../../Components/FormField';
import SidebarField from '../../../../Components/SidebarField';
import TextInput from '../../../../Components/TextInput';
import SelectDropdown from '../../../../Components/Dropdown/SelectDropdown';
import Button from '../../../../Components/Button';
import MultiSelectDropDown from '../../../../Components/Dropdown/MultiSelectDropDown';
import { useFetchAll } from '../../../../custom/FetchApiHook';
import ToggleField from '../../../../Components/ToggleField';
import { TaxRegimeApi } from '../../../../App/api/TaxRegime.api';
import { TaxRegimechema } from './ValidationSchema';
import { Dropdown } from 'primereact/dropdown';


function AddTaxRegime({ currentItems, getAllData, open, handleClose }) {
  // const TaxRegimeData = useFetchAll(() => AuthApi.getRoles());   
  const allTaxData = useFetchAll(() => TaxRegimeApi.getAllTaxMaster());
  const allTaxOptions=allTaxData.value?.data?.map((d)=>{  
    const op={
      name:`${d.name}@${d.rate?.$numberDecimal}`,
      label:d.name,
      rate:d.rate?.$numberDecimal,
      _id:d._id
    }
     return op
    })
  
  const initialValues = {
    name: currentItems?.name || '',
    appliedTaxes: currentItems?.appliedTaxes?.map((d)=>d._id)|| [],
    taxes: currentItems?.taxes1||[],
    active:currentItems?.active||false
  };
  
  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Data",values);
    try {
      // console.log('values', values);
      // Logic for creating or updating the role and permissions
      const response = currentItems?._id
        ? await TaxRegimeApi.updateTaxRegime(currentItems._id,values)
        : await TaxRegimeApi.createTaxRegime(values);

      getAllData();
      toast.success(currentItems?._id ? 'Tax Regime updated' : 'Tax Regime created');
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
  };

  

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={TaxRegimechema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id
                    ? "Update Role & Permissions"
                    : "Add New Role & Permissions"
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button
                    text={currentItems?._id ? "Update" : "Submit"}
                    type="submit"
                  />
                }
              >
                <FormField
                  label="Tax Regime Name"
                  tooltip="enter Tax Regime Name"
                >
                  <div className="flex items-center">
                    <TextInput
                      name="name"
                      type="text"
                      placeholder="Tax Regime Name"
                      value={values.name}
                      onChange={handleChange}
                    />
                  </div>
                  <ErrorMessage name="name" component="div" className="error" />
                </FormField>

                <FormField label="Tax" tooltip="Choose Taxes">
                  <MultiSelectDropDown
                    sx={{ width: "100%" }} // Optional custom style
                    name={`appliedTaxes`}
                    value={values.appliedTaxes}
                    options={allTaxOptions || []}
                    placeholder="Select options"
                    handleMultiselectChange={(e, ob) => {
                      // console.log("e", e);                   
                      setFieldValue("appliedTaxes", e);   
                      const copyTaxes=[]
                      allTaxOptions.forEach((t) => {                         
                         if (e.includes(t._id)) {
                         copyTaxes.push( {      
                            name:t.label,
                            rate:t.rate,
                            taxType:'',
                          })
                         }
                        })                            
                      setFieldValue("taxes", copyTaxes);
                    }}
                    required={true}
                    optionLabel="name"
                    optionValue="_id"
                  />
                  <ErrorMessage
                    name="appliedTaxes"
                    component="p"
                    className="error"
                  />
                </FormField>
                
                <div>                 
                  {values.taxes.length ? values.taxes.map((d, i) => (
                      <div key={i} className='border p-2 my-2 '>
                        <FormField label="Tax Name" tooltip="Enter Tax Name">                       
                          <div className="flex items-center">
                            <TextInput
                              name="name"
                              type="text"
                              placeholder="Tax Name"
                              value={d.name}
                              onChange={handleChange}
                              required={true}
                            />
                          </div>
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="error"
                          />
                        </FormField>
                        <div className="flex gap-2" >
                          <FormField label="Tax Rate" tooltip="Enter Tax Rate">
                            <div className="flex items-center">
                              <TextInput
                                name="rate"
                                type="text"
                                placeholder="Tax Rate"
                                value={d.rate}
                                onChange={handleChange}
                              />
                            </div>
                            <ErrorMessage
                              name="rate"
                              component="div"
                              className="error"
                            />
                          </FormField>
                          <FormField label="Tax Type" tooltip="Choose Tax Type" className='w-[60%]'>
                            <Dropdown
                              style={{borderRadius:"5px",height:"2.3rem",width:"100%"}}
                              value={d.taxType}
                              options={["REBASE TAX", "TAX"]}
                              name="taxType"
                              onChange={(e) => {
                                // console.log("e", e.value);
                                let TaxesCopy=[...values.taxes]
                                TaxesCopy[i]=TaxesCopy[i]===undefined?{}:TaxesCopy[i];
                                // console.log("TaxesCopy", TaxesCopy[i]);
                                TaxesCopy[i].taxType=e.value                               
                                setFieldValue('taxes',TaxesCopy)
                              }}
                              required={true}
                            />
                            <ErrorMessage
                              name="taxType"
                              component="p"
                              className="error"
                            />
                          </FormField>
                        </div>
                      </div>
                    )):''}
                </div>
                <div>
                  <ToggleField
                    text={values.active ? "Enabled" : "Disabled"}
                    name="active"
                    value={values.active}
                    toggaleHandleChange={(e) => {
                      // console.log("v", e.target.value);

                      setFieldValue("active", e.target.value);
                    }}
                  />
                  <ErrorMessage name="active" component="p" className="error" />
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddTaxRegime;
